module.exports = __webpack_public_path__ + "04_hair_black.eff288cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/04_hair_black.png
// module id = 4NYf
// module chunks = 0